import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RCP_DIALOG_ITEMS } from '@app/constants/RCP_DIALOG_ITEMS';
import { DataTestIdPipe } from '@app/pipes/data-test-id/data-test-id-pipe';
import { AppStore } from '@app/stores/app/app.store';
import type { IModalData } from '@app/types/modal-data';

@Component({
    selector: 'app-confirm-dialog',
    imports: [RCP_DIALOG_ITEMS, MatButtonModule, DataTestIdPipe, MatIconModule],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;

    readonly data = inject<IModalData>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef);
    onYesClick(e: Event) {
        e.preventDefault();
        this.dialogRef.close(true);
    }
    onClose(e: Event) {
        e.preventDefault();
        this.dialogRef.close();
    }
}
